var link_viewer_wrapper_default = {
  "anchor": "p8vLN",
  "link": "CiFvl"
};
export {
  link_viewer_wrapper_default as default
};
//# sourceMappingURL=link-viewer-wrapper-scss.js.map
